<template>
<div><AboutUsNav></AboutUsNav>
  <div class="about-yy">
    <h3 class="about-h3-yy">企业荣誉</h3>
    <div style="position: absolute;width: 100%">
      <img
        class="about-yy-img"
        src="@/assets/images/About_Four.png"
      >
      <span></span>
    </div>

    <div v-swiper:mySwiper="smSwiperOptionMobile">
      <div class="swiper-wrapper">
        <!-- margin-left:-374px;margin-left:-834px;margin-left:-827px; -->
        <div class="swiper-slide swiper-slide222">
          <img
            src="@/assets/images/About_5.png"
            class="swiper-img-now"
          >
          <img
            src="@/assets/images/About_6.png"
            class="swiper-img-now"
          >
          <img
            src="@/assets/images/About_7.png"
            class="swiper-img-now"
          >
        </div>

        <div class="swiper-slide swiper-slide222">
          <img
            src="@/assets/images/About_8.png"
            class="swiper-img-now"
          >
          <img
            src="@/assets/images/About_9.png"
            class="swiper-img-now"
          >
          <img
            src="@/assets/images/About_10.png"
            class="swiper-img-now"
          >
        </div>

        <div class="swiper-slide swiper-slide222">
          <img
            src="@/assets/images/About_11.png"
            class="swiper-img-now"
          >
          <img
            src="@/assets/images/About_12.png"
            class="swiper-img-now" style="width:142px;height:170px;"
          >
        </div>
      </div>
      <div
        class="swiper-button-prev"
        style="top:80%;left:30px;"
      ></div>
      <div
        class="swiper-button-next"
        style="top:80%;right:30px;"
      ></div>
    </div>
  </div>
</div>
</template>



<script>
// import { formatDate } from '@/assets/js/date.js'
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
      smSwiperOptionMobile: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000,                      // 几秒播放一次
          disableOnInteraction: false       // 手动滑动后是否停止自动播放
        },
        loop: true,
        speed: 300									// 滚动速度
      },
    }
  },

  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)

    // 加载路由参数
    this.getRouteQuery()
    // 请求列表数据
    this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  components: {
    AboutUsNav
  }


}
</script>
<style scoped>
.swiper-img-now {
  width: 260px;
  height: 170px;
  margin-left: 36px;
}
.swiper-slide222 {
  /* margin-right: 30px; */
  margin-top: 16%;
}
@media screen and (max-width: 540px) {
  .swiper-img-now {
    width: 100px;
    height: 76px;
    margin-left: 16px;
  }
  .swiper-slide222 {
    /* margin-right: 30px; */
    margin-top: 26%;
  }
}
</style>